import { CategoryColour } from '../../data/gql-gen/questionnaire/graphql'
import {
  QuestionKind,
  QuestionTypeCode,
  SettingInputInput
} from '../../data/model/questionnaire'

export interface Option {
  id: string
  position?: number
  value?: string
  isNew?: boolean
  isChecked?: boolean
  colour?: CategoryColour
}

export type Row = Option

export enum EntryType {
  BasicType = 'BasicType',
  FreeTextType = 'FreeTextType',
  MatrixType = 'MatrixType',
  RankedType = 'RankedType',
  ScaleType = 'ScaleType',
  TextCardType = 'TextCardType',
  TextHighlighterType = 'TextHighlighterType',
  // Recognised only when the parser is asked for translation-only types: their
  // text is read back from the exported document, but neither can be CREATED
  // from a .docx yet (see DocxProcessor.hooks.ts).
  MaxDiffType = 'MaxDiffType',
  ConjointType = 'ConjointType'
}

export type RawQuestionnaireEntry = {
  id: string
  position?: number
  entryType: EntryType
  kind: QuestionKind
  questionType: QuestionTypeCode
  title: string
  styling?: string
  subtitle?: string
  options: Option[]
  setting?: SettingInputInput
  rows: Row[]
  qNum?: string
  isNew?: boolean
  isChecked?: boolean
  body?: string
  // Slider endpoint labels, keyed by scale position (0 left, 1 central,
  // 2 right). Only populated for ScaleType, and only used by the translation
  // import — the questionnaire-creation transform ignores it.
  scaleLabels?: { position: number; value: string }[]
  // MaxDiff instruction labels and conjoint attributes. Populated only when the
  // parser is asked to keep translation-only question types.
  maxDiffLabels?: {
    mostLabel?: string
    leastLabel?: string
    attributeLabel?: string
  }
  attributes?: { name: string; levels: string[] }[]
}

export type RawQuestionnaireEntryInput = Omit<
  RawQuestionnaireEntry,
  'id' | 'isChecked' | 'qNum'
>
